import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { ChainLink, chainByRequest, demandRequestPath, fulfillmentOrderPath, transferOrderPath } from '../chain'

/**
 * The fulfillment chain of a pick order, laid out the way it flows: each
 * request, the fulfillment orders made for it, and the transfer orders their
 * cartons became. One row per fulfillment order; a request spans its orders.
 */
export default function FulfillmentChainTable( { chain, label }: { chain: ChainLink[], label: string } ) {
	const groups = chainByRequest( chain )

	return (
		<Table size="small" aria-label={label} sx={{ '& td, & th': { borderColor: 'pickFlow.cardBorder' } }}>
			<TableHead>
				<TableRow>
					<TableCell sx={{ fontWeight: 600, width: '20%' }}>Request</TableCell>
					<TableCell sx={{ fontWeight: 600, width: '20%' }}>Fulfillment order</TableCell>
					<TableCell sx={{ fontWeight: 600 }}>Transfer orders</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{groups.flatMap( ( group ) => group.orders.map( ( order, index ) => (
					<TableRow key={order.orderId}>
						{index === 0 && (
							<TableCell rowSpan={group.orders.length} sx={{ verticalAlign: 'top' }}>
								{group.request
									? <Link to={demandRequestPath( group.request.id )}>REQ-{group.request.requestNumber}</Link>
									: <Typography variant="body2" color="text.secondary" component="span">No request</Typography>}
							</TableCell>
						)}
						<TableCell>
							<Link to={fulfillmentOrderPath( order.orderNumber )}>FO-{order.orderNumber}</Link>
						</TableCell>
						<TableCell>
							{order.transferOrderIds.length > 0 ? (
								<Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 2, rowGap: 0.5 }}>
									{order.transferOrderIds.map( ( id ) => (
										<Link key={id} to={transferOrderPath( id )}>TO-{id}</Link>
									) )}
								</Box>
							) : (
								<Typography variant="body2" color="text.secondary" component="span">
									Created when finalized
								</Typography>
							)}
						</TableCell>
					</TableRow>
				) ) )}
			</TableBody>
		</Table>
	)
}
